import { yyyy } from "../../store.svelte";
const url: string = yyyy.uri.api;

export default async () => {
	let _hdrs = {
		"Content-Type": "application/json",
		Authorization: "Bearer " + yyyy.sesh.logtoken.token,
		Accept: "application/json",
	};
	let _body = JSON.stringify({ lw_id: yyyy.sesh.activeLivewire.wireident });
	let fetchopts = { method: "post", headers: _hdrs, body: _body };

	const resp = await fetch(`${url}/rpc/getlayernames`, fetchopts);
	if (resp.ok) {
		let data = await resp.json();
		// console.log(data);
		data.layernames.forEach((element: any) => {
			element.vis = true;
		});
		yyyy.map.zote.layerlist = data.layernames;
		// console.log("layerlist:", data.layernames);
		let ret = data.layernames
		// console.log(ret)
		return ret
	}
	if (!resp.ok) {
		console.log("fetching layers failed");
	}
};
